export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const GET_TRADES = "GET_TRADES";
export const TRADES_LOADING = "TRADES_LOADING";
export const TRADES_LOADING_FINISHED = "TRADES_LOADING_FINISHED";
export const REPORTS_LOADING="REPORTS_LOADING";
export const REPORTS_LOADING_FINISHED="REPORTS_LOADING_FINISHED"
export const RESET_LOADING="RESET_LOADING"
export const FINISH_LOADING="FINISH_LOADING"